import { Ads, Dashboard, Loader, Welcome } from '@/components';
import { useUserProfile } from '@/hooks/useUserProfile';
import { DialogsProvider } from './DialogsContext';
import { PublicAuthLayout } from './PublicAuthLayout';
import { CATALOG_ADS_PER_PAGE } from '@/components/Ads/constants';

export const HomePage = () => {
  const { isLoading, isLoggedIn } = useUserProfile();

  if (isLoading || isLoggedIn === null) {
    return <Loader />;
  }

  if (isLoggedIn) {
    return (
      <Dashboard isSearch>
        <Ads adsPerPage={CATALOG_ADS_PER_PAGE} enableAmbassadorPromotion enableTopAgentFilter />
      </Dashboard>
    );
  }

  return (
    <DialogsProvider>
      <PublicAuthLayout>
        <Welcome />
      </PublicAuthLayout>
    </DialogsProvider>
  );
};
